import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import lottie from "lottie-web";
import URL from "../../../../constant/URL";
import useSound from "../../../../hooks/useSound";
import { useAppBackBtn } from "../../../../hooks";

let Analysis = ( props ) => {
  const { t } = useTranslation();
  const { setSound, playSound, clearSound } = useSound();
  const { initBackEventData } = useAppBackBtn();

  const [message, setMessage] = React.useState(`${t("LC_02_07.msg001")}...`);

  useEffect(() => {
    initBackEventData();
    window.addEventListener("backgroundApp", (e) => {
      clearSound();
    });
  }, []);

  const mount = () => {

    const animation = lottie.loadAnimation( {
      container : document.querySelector( '#img_lc_02_07' ),
      path : `${ process.env.PUBLIC_URL }/static/json/img_lc_02_07.json`,
      renderer : 'svg',
      loop : false,
      autoplay : true
    } );

    const enterFrame = ( event ) => {
      if ( 13 < event.currentTime ) {
        animation.setSpeed( 1 );
        animation.removeEventListener( 'enterFrame', enterFrame );
      }
    };

    const complete = () => {
      animation.goToAndPlay( 16, true );
    };

    animation.setSpeed( 0.6 );
    animation.addEventListener( 'enterFrame', enterFrame );
    animation.addEventListener( 'complete', complete );

    setSound( {
      src : `${ process.env.PUBLIC_URL }/static/audio/lc_02_07.ogg`,
      loop : true
    } );
    playSound();

    let count = 0;

    const updateMessage = () => {
      count++;
      switch ( count ) {
        case 1 :
          setMessage(`${t("LC_02_07.msg004")}...` );
          break;
        case 2 :
          setMessage(`${t("LC_02_07.msg003")}...`);
          break;
      }
      3 === count && props.history.replace( URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT );
    };

    const timer = setInterval( updateMessage, 2000 );

    return () => {
      animation.removeEventListener( 'enterFrame', enterFrame );
      animation.removeEventListener( 'complete', complete );
      animation.destroy();
      clearSound();
      clearInterval( timer );
    };

  };

  React.useEffect( mount, [] );

  return (

    <div className="layout-def layout-lc theme-white">
      <div className="header">
        <div className="inner">
          <div className="headerBox">
            <div className="headerBox_head">
              <h1 className="tit">{t("LC_02_07.msg001")}</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="inner">
          <div className="d-flex full f-middle">
            <div className="d-item">
              <div className="aic-predicBox">
                <div className="aic-predicBox-aniBox">
                  <div id="img_lc_02_07" className="anim-wrap" />
                </div>
                <p className="justTxt">{ message }</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );

};

Analysis = withRouter( Analysis );

export default Analysis;
